import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

import {
  createRootRouteRefsPair,
  createSubRouteRefsPair,
} from '@spotify/confidence-core-react';

export enum RoutesIds {
  metrics = 'metrics',
  metric = 'metric',
}

enum ExternalRoutesIds {
  workflowInstance = 'workflowInstance',
  entities = 'entities',
  entity = 'entity',
  factTables = 'factTables',
  factTable = 'factTable',
  factTablesCreate = 'factTablesCreate',
  assignmentTable = 'assignmentTable',
  assignmentTablesCreate = 'assignmentTablesCreate',
  metricsDataWarehouse = 'metricsDataWarehouse',
}

// root route
export const [metricsRouteImplRef, metricsRouteRef] = createRootRouteRefsPair({
  id: RoutesIds.metrics,
});

export const rootRouteRef = metricsRouteImplRef;

// sub-routes within the plugin
export const [metricRouteImplRef, metricRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.metric,
  path: '/:id',
  parent: rootRouteRef,
});

export const workflowInstanceRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.workflowInstance,
  params: ['workflow', 'id'],
  optional: true,
});

// external routes to other plugins
export const factTablesRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.factTables,
  optional: true,
});

export const factTableRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.factTable,
  params: ['id'],
  optional: true,
});

export const factTablesCreateRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.factTablesCreate,
  optional: true,
});

export const entitiesRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entities,
  optional: true,
});

export const entityRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entity,
  params: ['id'],
  optional: true,
});

export const assignmentTableRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.assignmentTable,
  params: ['id'],
  optional: true,
});

export const assignmentTablesCreateRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.assignmentTablesCreate,
  optional: true,
});

export const metricsDataWarehouseRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.metricsDataWarehouse,
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  metrics: metricsRouteImplRef,
  metric: metricRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // sub-routes within the plugin
  metrics: metricsRouteRef,
  metric: metricRouteRef,

  // routes to other plugins
  workflowInstance: workflowInstanceRouteRef,
  factTable: factTableRouteRef,
  factTables: factTablesRouteRef,
  factTablesCreate: factTablesCreateRouteRef,
  entities: entitiesRouteRef,
  entity: entityRouteRef,
  assignmentTable: assignmentTableRouteRef,
  assignmentTablesCreate: assignmentTablesCreateRouteRef,
  metricsDataWarehouse: metricsDataWarehouseRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef> &
  Record<ExternalRoutesIds, ExternalRouteRef>;
